import React from "react";
//import FullWidthCenteredLayout from "../../components/FullWidthCenteredLayout/FullWidthCenteredLayout";
import AuthPageLayout from "./AuthPageLayout";
import Auth2fa from "./components/Auth2fa";
import AuthAnonymous from "./components/AuthAnonymous";
import AuthPii from "./components/AuthPii";
import AuthB2C from "./components/AuthB2C";
const AuthPageRoutes = {
  path: "auth",
  element: <AuthPageLayout />,
  children: [
    { path: "", element: <AuthB2C /> },
    { path: "2fa", element: <Auth2fa /> },
    { path: "pii", element: <AuthPii /> },
    { path: "Anonymous", element: <AuthAnonymous /> },
    { path: "b2c", element: <AuthB2C /> },
  ],
};

export default AuthPageRoutes;
